
import CancelButton from "@/components/buttons/CancelButton.vue";
import EditButton from "@/components/buttons/EditButton.vue";
import DangerDialog from "@/components/dialogs/DangerDialog.vue";
import { UsersModule } from "@/store/modules/UsersModule";
import { Component, Vue } from "vue-property-decorator";
import api from "@/api";

@Component({
  components: {
    EditButton,
    CancelButton,
    DangerDialog,
  },
})
export default class LoginView extends Vue {
  isInputValid = false;
  isLoading = false;
  showResetPasswordDialog = false;
  showPassword: boolean = false;
  email: string | null = null;
  resetEmail: string | null = null;
  password: string | null = null;

  wrongLoginTimeout: number | null = null;
  emailSentTimeout: number | null = null;

  // background images

  backgroundImages = [
    require("@/assets/fahrradbox_start.jpg"),
    require("@/assets/fahrradgarage_Frau.jpg"),
    require("@/assets/fahrradgarage_marbach.jpg"),
    require("@/assets/fahrradgarage_varianten.jpg"),
    require("@/assets/home_fahrradgarage_secanda_pc.jpg"),
    require("@/assets/iStock-1139819021-Frau-mit-Fahrrad-am-Wasser-2121x1414-1-1024x683-2.jpg"),
    require("@/assets/sole-bicycles-JK6lD_y3aDg-unsplash.jpg"),
    require("@/assets/BikeParkBox_Radfahrerin_App.jpg"),
    require("@/assets/dillon-wanner-FlewGATv_x0-unsplash.jpg"),
    require("@/assets/fahrradbox_bike_ride.jpg"),
    require("@/assets/Fahrradgarage-grau-mit-Fahrradmotiv-und-Smartphone-1.png"),
  ];

  currentBackgroundImage = "";

  async mounted(): Promise<void> {
    await UsersModule.logout(false);
    this.setRandomBackground();
  }

  setRandomBackground(): void {
    const randomIndex = Math.floor(
      Math.random() * this.backgroundImages.length
    );
    this.currentBackgroundImage = this.backgroundImages[randomIndex];
  }

  async onLoginSubmit(): Promise<void> {
    this.isLoading = true;
    try {
      await UsersModule.login({
        email: this.email!,
        password: this.password!,
      });
      this.isLoading = false;
      this.$router.push("/station");
    } catch (e) {
      this.isLoading = false;
      this.clearWrongLoginTimeout();
      this.wrongLoginTimeout = setTimeout(() => {
        this.wrongLoginTimeout = null;
      }, 5000);
    }
  }

  clearWrongLoginTimeout(): void {
    if (this.wrongLoginTimeout != null) {
      clearTimeout(this.wrongLoginTimeout);
      this.wrongLoginTimeout = null;
    }
  }

  onEmailResetSubmit(): void {
    api.UsersApi.startPasswordReset(this.resetEmail!);
    this.clearEmailSentTimeout();
    this.emailSentTimeout = setTimeout(() => {
      this.emailSentTimeout = null;
    }, 5000);
  }

  clearEmailSentTimeout(): void {
    if (this.emailSentTimeout != null) {
      clearTimeout(this.emailSentTimeout);
      this.emailSentTimeout = null;
    }
  }
}
